import { Pipe, PipeTransform } from '@angular/core';

import { formatScheduleDateTime } from '@shared/utils';

@Pipe({
  name: 'scheduleDateTime',
  standalone: true,
})
export class ScheduleDateTimePipe implements PipeTransform {
  transform(value?: string, timeZone?: string): string {
    return formatScheduleDateTime(value, timeZone);
  }
}
